import React from "react";

function Employee() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="25"
      fill="none"
      viewBox="0 0 24 25"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M15 8.143a3 3 0 11-6 0 3 3 0 016 0zM16 4.143a3 3 0 011.218 5.742M13.714 14.143h-3.428A4.286 4.286 0 006 18.43c0 .947.768 1.714 1.714 1.714h8.572c.947 0 1.714-.767 1.714-1.714a4.286 4.286 0 00-4.286-4.286zM17.714 13.143A4.286 4.286 0 0122 17.43c0 .947-.767 1.714-1.714 1.714M8 4.143a3 3 0 00-1.218 5.742M3.714 19.143A1.714 1.714 0 012 17.43a4.286 4.286 0 014.286-4.286"
      ></path>
    </svg>
  );
}

export default Employee;
